import { render, staticRenderFns } from "./_nlc.vue?vue&type=template&id=f8fb94b8&lang=pug&"
import script from "./_nlc.vue?vue&type=script&lang=js&"
export * from "./_nlc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports